// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compose-form .mat-mdc-form-field {
  width: 100%;
}
.compose-form .show-hide-extra-fields {
  text-align: right;
  cursor: pointer;
  font-size: 12px;
}
.compose-form .attachment-list {
  font-size: 13px;
}
.compose-form .attachment-list .attachment {
  border: 1px solid;
  border-radius: 20px;
  padding-left: 16px;
  margin-top: 8px;
}
.compose-form .attachment-list .attachment .filename {
  font-weight: 600;
}
.compose-form .attachment-list .attachment:last-child {
  margin-bottom: 0;
}

.fr-box.fr-basic.fr-top .fr-wrapper {
  min-height: 100px !important;
}

@media screen and (max-width: 599px) {
  .pdf-dialog {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .pdf-dialog {
    width: 85%;
  }
}
.pdf-dialog .mat-mdc-dialog-container {
  padding: 0;
}
.pdf-dialog .dialog-content-wrapper {
  max-height: 85vh;
  display: flex;
  flex-direction: column;
}
.pdf-dialog .primary-color-input,
.pdf-dialog .secondary-color-input {
  padding: 6px 8px;
}

mat-radio-button {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/main/properties/properties-print-email/properties-print-email.component.scss","webpack://./src/@fuse/scss/partials/_breakpoints.scss"],"names":[],"mappings":"AAGI;EACI,WAAA;AAFR;AAKI;EACI,iBAAA;EACA,eAAA;EACA,eAAA;AAHR;AAMI;EACI,eAAA;AAJR;AAMQ;EACI,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAJZ;AAMY;EACI,gBAAA;AAJhB;AAOY;EACI,gBAAA;AALhB;;AAWA;EACI,4BAAA;AARJ;;ACOQ;EDIR;IAEQ,WAAA;EARN;AACF;ACCQ;EDIR;IAMQ,UAAA;EAPN;AACF;AASI;EACI,UAAA;AAPR;AAUI;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;AARR;AAWI;;EAEI,gBAAA;AATR;;AAcA;EACI,cAAA;AAXJ","sourcesContent":["@import \"src/@fuse/scss/partials/breakpoints\";\n\n.compose-form {\n    .mat-mdc-form-field {\n        width: 100%;\n    }\n\n    .show-hide-extra-fields {\n        text-align: right;\n        cursor: pointer;\n        font-size: 12px;\n    }\n\n    .attachment-list {\n        font-size: 13px;\n\n        .attachment {\n            border: 1px solid;\n            border-radius: 20px;\n            padding-left: 16px;\n            margin-top: 8px;\n\n            .filename {\n                font-weight: 600;\n            }\n\n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n    }\n}\n\n.fr-box.fr-basic.fr-top .fr-wrapper {\n    min-height: 100px !important;\n}\n\n.pdf-dialog {\n    @include media-breakpoint(\"xs\") {\n        width: 100%;\n    }\n\n    @include media-breakpoint(\"gt-xs\") {\n        width: 85%;\n    }\n\n    .mat-mdc-dialog-container {\n        padding: 0;\n    }\n\n    .dialog-content-wrapper {\n        max-height: 85vh;\n        display: flex;\n        flex-direction: column;\n    }\n\n    .primary-color-input,\n    .secondary-color-input {\n        padding: 6px 8px;\n    }\n}\n\n\nmat-radio-button {\n    display: block;\n}\n","// Media step breakpoint mixin based on Angular Material lib\n$breakpoints: (\n    xs: 'screen and (max-width: 599px)',\n    sm: 'screen and (min-width: 600px) and (max-width: 959px)',\n    md: 'screen and (min-width: 960px) and (max-width: 1279px)',\n    lg: 'screen and (min-width: 1280px) and (max-width: 1919px)',\n    xl: 'screen and (min-width: 1920px) and (max-width: 5000px)',\n    lt-sm: 'screen and (max-width: 599px)',\n    lt-md: 'screen and (max-width: 959px)',\n    lt-lg: 'screen and (max-width: 1279px)',\n    lt-xl: 'screen and (max-width: 1919px)',\n    gt-xs: 'screen and (min-width: 600px)',\n    gt-sm: 'screen and (min-width: 960px)',\n    gt-md: 'screen and (min-width: 1280px)',\n    gt-lg: 'screen and (min-width: 1920px)'\n) !default;\n\n// Re-map the breakpoints for the helper classes\n$helper-breakpoints: (\n    xs: null,\n    sm: 'gt-xs',\n    md: 'gt-sm',\n    lg: 'gt-md',\n    xl: 'gt-lg'\n);\n\n@mixin media-breakpoint($breakpointName) {\n\n    $mediaQuery: map-get($breakpoints, $breakpointName);\n\n    @if ($mediaQuery == null) {\n        @content\n    } @else {\n        @media #{$mediaQuery} {\n            @content\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
